import React, { Component } from "react";
import {pathHelper} from "../../../helpers/path-helper";

class NodeRedUI extends Component {
    render() {
        return(
            <iframe className="node-red" src={`http://${pathHelper.getUrlHostname()}:1880/ui`} title="Node red UI"/>
        )
    }
}
export default NodeRedUI;
